import { defineAsyncComponent } from 'vue'

export const LanguagesFlags = [
  {
    shortcut: 'cs',
    link: 'https://www.mixit.cz',
    svg: defineAsyncComponent(() => import('@/components/svg/flags/FlagCzSvg.vue')),
  },
  {
    shortcut: 'sk',
    link: 'https://www.mixit.sk',
    svg: defineAsyncComponent(() => import('@/components/svg/flags/FlagSkSvg.vue')),
  },
  {
    shortcut: 'pl',
    link: 'https://www.mixit.pl',
    svg: defineAsyncComponent(() => import('@/components/svg/flags/FlagPlSvg.vue')),
  },
  {
    shortcut: 'hu',
    link: 'https://www.mixit.hu',
    svg: defineAsyncComponent(() => import('@/components/svg/flags/FlagHuSvg.vue')),
  },
  {
    shortcut: 'ro',
    link: 'https://www.mixit.ro',
    svg: defineAsyncComponent(() => import('@/components/svg/flags/FlagRoSvg.vue')),
  },
  {
    shortcut: 'de',
    link: 'https://www.mixit.de',
    svg: defineAsyncComponent(() => import('@/components/svg/flags/FlagDeSvg.vue')),
  },
  {
    shortcut: 'at',
    link: 'https://www.mixit.at',
    svg: defineAsyncComponent(() => import('@/components/svg/flags/FlagAtSvg.vue')),
  },
  {
    shortcut: 'fr',
    link: 'https://www.mixit.fr',
    svg: defineAsyncComponent(() => import('@/components/svg/flags/FlagFrSvg.vue')),
  },
  /* {
    shortcut: 'it',
    link: 'https://www.mixit.it',
    svg: defineAsyncComponent(() => import('@/components/svg/flags/FlagItSvg.vue')),
  }, */
]

export const getCurrentLocaleFlag = (locale) => {
  const languageSvg = LanguagesFlags.find((language) => language.shortcut === locale)
  if (languageSvg) {
    return languageSvg.svg
  }
}
